import axios from '@/shared/api/axios';
import { COMPANY_ENDPOINTS } from '@/shared/api/apiEndpoints';

interface ApiResponse {
  success: boolean;
  data: any;
  error?: {
    message: string;
    details: any;
  };
  timestamp: string;
}

export const getCompanyData = async (companyId: string): Promise<ApiResponse> => {
  try {
    const response = await axios.get(COMPANY_ENDPOINTS.GETDATA(companyId));
    console.log(response.data.data);
    return response.data;
  } catch (error) {
    return {
      success: false,
      data: null,
      error: {
        message: '회사 정보를 가져오는데 실패했습니다.',
        details: error
      },
      timestamp: new Date().toISOString()
    };
  }
};
